import { useState } from "react";
import { ChevronRight } from "lucide-react";
import ReportActivityGroup from "./ReportActivityGroup";

const MINI_BTN =
  "text-xs font-medium text-indigo-600 hover:text-indigo-700 px-2 py-1 rounded-lg hover:bg-indigo-50 transition-colors";

function BlockSection({ block, selected, onToggle, onSetMany }) {
  const [isOpen, setIsOpen] = useState(false);
  const blockIds = block.activities.flatMap((activity) =>
    activity.questions.map((question) => question.questionId)
  );
  const selectedCount = blockIds.filter((id) => selected.has(id)).length;

  return (
    <div>
      <div className="px-4 py-3 flex items-center gap-2 bg-gray-50">
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="flex items-center gap-2 flex-1 min-w-0 text-left"
        >
          <ChevronRight
            size={16}
            className={`shrink-0 text-gray-400 transition-transform ${
              isOpen ? "rotate-90" : ""
            }`}
          />
          <span className="font-medium text-gray-900 truncate">
            {block.blockName}
          </span>
          <span className="shrink-0 text-xs text-gray-500">
            {selectedCount}/{blockIds.length} preguntas
          </span>
        </button>
        <button onClick={() => onSetMany(blockIds, true)} className={MINI_BTN}>
          Todas
        </button>
        <button onClick={() => onSetMany(blockIds, false)} className={MINI_BTN}>
          Ninguna
        </button>
      </div>

      {isOpen && (
        <div className="px-4 py-3 space-y-3">
          {block.activities.map(({ template, questions }) => (
            <ReportActivityGroup
              key={template.id}
              template={template}
              questions={questions}
              selected={selected}
              onToggle={onToggle}
              onSetMany={onSetMany}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function ActivityReportSelector({
  blocks,
  selected,
  totalCount,
  onToggle,
  onSetMany,
}) {
  const allIds = blocks.flatMap((block) =>
    block.activities.flatMap((activity) =>
      activity.questions.map((question) => question.questionId)
    )
  );

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 flex flex-wrap items-center justify-between gap-2 border-b border-gray-100">
        <div>
          <h2 className="font-semibold text-gray-900">Preguntas del informe</h2>
          <p className="text-xs text-gray-500">
            {selected.size} de {totalCount} seleccionadas
          </p>
        </div>
        <div className="flex items-center gap-1">
          <button onClick={() => onSetMany(allIds, true)} className={MINI_BTN}>
            Seleccionar todo
          </button>
          <button onClick={() => onSetMany(allIds, false)} className={MINI_BTN}>
            Ninguno
          </button>
        </div>
      </div>

      <div className="divide-y divide-gray-100">
        {blocks.map((block) => (
          <BlockSection
            key={block.blockName}
            block={block}
            selected={selected}
            onToggle={onToggle}
            onSetMany={onSetMany}
          />
        ))}
      </div>
    </div>
  );
}
